import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'secondary' | 'outline' | 'ghost' | 'link' | 'premium';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}
export function Button({
  className = '',
  variant = 'default',
  size = 'default',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 active:scale-95';
  const variants = {
    default: 'bg-blue-600 text-white hover:bg-blue-700 shadow-md hover:shadow-lg',
    secondary: 'bg-slate-100 text-slate-900 hover:bg-slate-200 border border-slate-200',
    outline: 'border border-slate-200 bg-white hover:bg-slate-50 hover:text-blue-700 hover:border-blue-200 shadow-sm',
    ghost: 'hover:bg-slate-100 hover:text-slate-900',
    link: 'text-blue-600 underline-offset-4 hover:underline',
    premium: 'bg-gradient-to-r from-blue-700 to-blue-500 text-white hover:from-blue-800 hover:to-blue-600 shadow-lg hover:shadow-blue-500/25 border border-blue-600/20'
  };
  const sizes = {
    default: 'h-10 px-5 py-2',
    sm: 'h-9 rounded-md px-3',
    lg: 'h-12 rounded-lg px-8 text-base',
    icon: 'h-10 w-10'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  return <button className={classes} {...props} data-id="element-268">
      {children}
    </button>;
}